import {ARCHIVED_MEMBERS_REQUEST, ARCHIVED_MEMBERS_SUCCESS,ARCHIVED_MEMBERS_FAIL} from "../constants/AuthConstant"

const initialState = {
  loading: false,
  action: "All Action",
  result: [],
  msg: "",
  error: "",
};

const ArchivedMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case ARCHIVED_MEMBERS_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case ARCHIVED_MEMBERS_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case ARCHIVED_MEMBERS_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default ArchivedMembersReducer;
